import React, { useEffect, useState } from "react";
import { Grid, Typography, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "../common/TextField";
import MenuItem from "../common/MenuItem";
import Button from "../common/Button";
import instance from "../../axios";
import { useDispatch, useSelector } from "react-redux";
import { checkPrivileges, handleDownloadOrPreview } from "../../Helpers";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { toast } from "react-toastify";
import AsyncSelect from "../common/asyncSelect";
import CustomDatePicker from "../common/CustomDatePicker";
import moment from "moment";

const getFileName = (file) => {
  if (!file) return "";
  if (file.name) return file.name;
  if (typeof file === "string") {
    return decodeURIComponent(file.split("/").pop());
  }
  if (file.url) {
    return decodeURIComponent(file.url.split("/").pop());
  }
  return "";
};
const TICKET_TYPE_DEPARTMENTS = {
  support: "Technical Support",
  training: "Technical Support",
  "new change request": "Development",
  "bug fix": "Development",
  "general inquiry": "Operations",
  others: "Operations",
  "general request": "Operations",
  "payment billing": "Billing",
};
const CreateTicketForm = ({ translate, handleAddCloseForm, selectedTask }) => {
  const ServerSetting = useSelector((state) => state.ServerSetting);
  const logInUser = useSelector((state) => state.logInUsers);
  const [loader, setLoader] = useState(false);
  const [form, setForm] = useState({
    name: "",
    assignTo: "",
    description: "",
    currentStatus: "",
    date: "",
    ticketType: "",
    department: "",
    priority: "",
    labels: ["", "", "", ""],
    file: null,
  });
  const [resultMessage, setResultMessage] = useState("");
  const [resultMessageUser, setResultMessageUser] = useState("");

  const [defaultAccountsList, setDefaultAccountsList] = useState([]);
  const [defaultUsersList, setDefaultUsersList] = useState([]);

  useEffect(() => {
    if (selectedTask) {
      setForm({
        name: selectedTask.name || "",
        assignTo: selectedTask.assignTo || "",
        description: selectedTask.description || "",
        currentStatus: selectedTask.currentStatus || "",
        dueDate: selectedTask.dueDate || "",
        ticketType: selectedTask.ticketType || "",
        department: selectedTask.department || "",
        priority: selectedTask?.priority || "",
        labels: ["", "", "", ""],
        assignTo: selectedTask?.attributes?.assignUser,
        parentId:
          selectedTask?.attributes?.parentUser || selectedTask?.parentId || "",
        file: selectedTask?.file || null,
      });
    }
  }, [selectedTask]);

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
      ...(field === "ticketType" && TICKET_TYPE_DEPARTMENTS[value]
        ? { department: TICKET_TYPE_DEPARTMENTS[value] }
        : {}),
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    if (selectedFile.size > 5 * 1024 * 1024) {
      alert("File size must be less than 5MB");
      return;
    }
    const reader = new FileReader();
    reader.onload = (event) => {
      const base64 = event.target.result.split("base64,")[1];

      const obj = {
        name: selectedFile.name,
        contentType: selectedFile.type,
        oldUrl: "",
        entity: "ticket",
        entityId: selectedTask?.id,
        data: base64,
      };
      setForm((prevstate) => ({
        ...prevstate,
        file: obj,
      }));
    };
    reader.readAsDataURL(selectedFile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoader(true);
      let fileUrl = "";
      if (form?.file && !form.file.url && form.file.data) {
        const uploadRes = await instance.post("/api/uploads", form.file, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        fileUrl = uploadRes.url;
      } else {
        fileUrl = form?.file || "";
      }
      const payload = {
        ...(selectedTask?.id && { id: selectedTask.id }),

        attributes: {
          ...(selectedTask?.attributes || {}),
          ...(form.attributes || {}),
          ...(form.parentId && {
            parentUser: form.parentId,
            assignBy: logInUser?.name || "",
          }),
          ...(form.assignTo && {
            assignUser: form.assignTo,
            assignTo: form?.assignTo?.label || "",
          }),
        },

        ...(form.priority && { priority: form.priority }),

        name: form.name,
        contractNumber: form?.parentId?.contractNumber,
        department: form.department,
        ticketType: form.ticketType,
        description: form.description,
        file: fileUrl || "",
        parentId: form?.parentId?.id || 0,
        assignTo: form?.assignTo?.id || "",
        dueDate: form?.dueDate || "",
        currentStatus: form.currentStatus || "New",
        created: new Date(),
      };

      if (selectedTask?.id) {
        await instance.put(`/api/tickets/${selectedTask.id}`, payload);
      } else {
        await instance.post(`/api/tickets`, payload);
      }

      handleAddCloseForm();
      const msg = selectedTask ? "ticketUpdated" : "ticketAdded";
      toast.success(msg);
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  const searchAccountsList = async (inputValue) => {
    if (!inputValue) return [];
    try {
      const fetchApi = `/api/accounts/getlimiteddata?search=${inputValue}&all=true&userId=${logInUser.id}`;
      const response = await instance.get(fetchApi);
      const result =
        response?.map((acc) => ({
          ...acc,
          label: acc?.name || acc.label,
          name: acc.name,
          value: acc.id,
        })) || [];
      setResultMessage(result.length === 0 ? "No option found" : "");
      return result;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  useEffect(() => {
    fetchAccountsList();
  }, []);

  const fetchAccountsList = async () => {
    try {
      const fetchApi = `/api/accounts/getlimiteddata?search=&all=true&userId=${logInUser.id}`;
      const response = await instance.get(fetchApi);
      const accounts =
        response?.map((acc) => ({
          id: acc.id,
          label: acc?.name || acc?.label,
          contractNumber:acc?.contractNumber
        })) || [];

      if (ServerSetting?.id) {
        accounts.unshift({
          id: ServerSetting.id,
          label: ServerSetting.name,
        });
      }

      setDefaultAccountsList(accounts);
    } catch (err) {
      console.error("Failed to fetch accounts", err);
    }
  };

  const searchUsersList = async (inputValue) => {
    if (!inputValue) return [];
    try {
      const fetchApi = `/api/users/get?search=${inputValue}&all=true&userId=${logInUser.id}&userTypes=4`;
      const response = await instance.get(fetchApi);
      const users =
        response?.data?.map((acc) => ({
          id: acc?.entity?.id,
          label: acc?.entity?.name,
        })) || [];
      setResultMessageUser(users.length === 0 ? "No option found" : "");
      return users;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  useEffect(() => {
    fetchUsersList();
  }, []);

  const fetchUsersList = async () => {
    try {
      const fetchApi = `/api/users/get?userId=${logInUser.id}&all=true&page=1&limit=100&userTypes=4`;
      const response = await instance.get(fetchApi);
      const users =
        response?.data?.map((acc) => ({
          id: acc?.entity?.id,
          label: acc?.entity?.name,
        })) || [];
      setDefaultUsersList(users);
    } catch (err) {
      console.error("Failed to fetch users", err);
    }
  };
  const handleChangeDate = (name) => (date) => {
    const formatted = date ? moment(date).endOf("day").utc().format() : null;
    setForm((prev) => ({ ...prev, [name]: formatted }));
  };

  let serverTimeZone = logInUser?.attributes?.timezone || "Asia/Riyadh";

  const isBtnDisabled =
    !form.name ||
    !form.ticketType ||
    !form.department ||
    !form.description ||
    !form.parentId;
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2} px={2}>
        <Grid item xs={12} sm={6} md={3} style={{ zIndex: 99 }}>
          <AsyncSelect
            selectName="parentId"
            isMulti={false}
            isClearable
            value={form.parentId}
            placeholder={translate("searchAccount")}
            resultMessage={resultMessage}
            defaultOptions={defaultAccountsList}
            handleChange={handleChange}
            disabled={selectedTask}
            loadOptions={searchAccountsList}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            label={translate("ticketSubject")}
            variant="outlined"
            fullWidth
            value={form.name}
            required
            onChange={(e) => handleChange("name", e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            select
            label={translate("status")}
            variant="outlined"
            fullWidth
            value={form.currentStatus}
            onChange={(e) => handleChange("currentStatus", e.target.value)}
          >
            <MenuItem value="New">New</MenuItem>
            <MenuItem value="Assigned">Assigned</MenuItem>
            <MenuItem value="In Progress">In Progress</MenuItem>
            <MenuItem value="Awaiting Customer Response">
              Awaiting Customer Response
            </MenuItem>
            <MenuItem value="Resolved">Resolved</MenuItem>
            <MenuItem value="Closed">Closed</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            select
            label={translate("priorityLevel")}
            variant="outlined"
            fullWidth
            value={form.priority}
            onChange={(e) => handleChange("priority", e.target.value)}
          >
            <MenuItem value="Low">Low</MenuItem>
            <MenuItem value="Medium">Medium</MenuItem>
            <MenuItem value="High">High</MenuItem>
            <MenuItem value="Critical">Critical</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            select
            label={translate("ticketType")}
            variant="outlined"
            fullWidth
            required
            value={form.ticketType}
            onChange={(e) => handleChange("ticketType", e.target.value)}
          >
            <MenuItem value="support">Support</MenuItem>
            <MenuItem value="training">Training</MenuItem>
            <MenuItem value="new change request">New Change Request</MenuItem>
            <MenuItem value="bug fix">Bug Fix</MenuItem>
            <MenuItem value="general inquiry">General Inquiry</MenuItem>
            <MenuItem value="payment billing">Payment Billing</MenuItem>
            <MenuItem value="general request">General Request</MenuItem>
            <MenuItem value="others">Others</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            select
            label={translate("department")}
            variant="outlined"
            fullWidth
            required
            value={form.department}
            onChange={(e) => handleChange("department", e.target.value)}
          >
            <MenuItem value="Technical Support">Technical Support</MenuItem>
            <MenuItem value="Operations">Operations</MenuItem>
            <MenuItem value="Billing">Billing</MenuItem>
            <MenuItem value="Development">Development</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomDatePicker
            format="dd/MM/yyyy"
            error={false}
            label={translate("dueDate")}
            minDate={moment().tz(serverTimeZone)}
            fullWidth
            value={
              form.dueDate ? moment.tz(form.dueDate, serverTimeZone) : null
            }
            onChange={handleChangeDate("dueDate")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} style={{ zIndex: 99 }}>
          <AsyncSelect
            selectName="assignTo"
            isMulti={false}
            isClearable
            value={form.assignTo}
            placeholder={translate("assignTo")}
            resultMessage={resultMessage}
            defaultOptions={defaultUsersList}
            handleChange={handleChange}
            loadOptions={searchUsersList}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label={translate("description")}
            variant="outlined"
            fullWidth
            multiline
            required
            rows={3.5}
            style={{ padding: "0px" }}
            value={form.description}
            onChange={(e) => handleChange("description", e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={12}></Grid>
        {selectedTask && (
          <Grid item xs={12}>
            <Typography mb={1}>{translate("addFile")}</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                variant="outlined"
                component="label"
                size="small"
                disabled={!!form?.file}
                sx={{
                  cursor: form?.file ? "not-allowed" : "pointer",
                  opacity: form?.file ? 0.6 : 1,
                }}
              >
                {form?.file ? getFileName(form.file) : translate("chooseFile")}
                <input
                  type="file"
                  hidden
                  disabled={form?.file}
                  onChange={handleFileChange}
                />
              </Button>
              {selectedTask?.file && !form.file?.name && (
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => handleDownloadOrPreview(selectedTask.file)}
                >
                  <VisibilityIcon fontSize="small" />
                </IconButton>
              )}
              {form?.file && (
                <>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() =>
                      setForm((prev) => ({
                        ...prev,
                        file: null,
                      }))
                    }
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </Box>
          </Grid>
        )}
        {(checkPrivileges("ticketCreate") ||
          (selectedTask && checkPrivileges("ticketUpdate"))) && (
          <Grid item xs={12}>
            <Box my={2} display="flex" justifyContent="flex-end">
              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={isBtnDisabled}
              >
                {selectedTask ? translate("update") : translate("submit")}
              </Button>
            </Box>
          </Grid>
        )}
      </Grid>
    </form>
  );
};

export default CreateTicketForm;
